import styled from "styled-components";

import { SimpleChipItem, Tooltip } from "@similarweb/ui-components";
import { Text, Flex } from "@similarweb/ui-components/foundations";

interface IEmailsListProps {
    emails: string[];
    onRemoveEmail: (email: string) => void;
}

const EmailsListContainer = styled(Flex)`
    max-height: 102px;
    min-height: 102px;
    flex-wrap: wrap;
    overflow-y: auto;
    margin-top: 10px;
    width: 100%;
    align-content: flex-start;
`;

const TooltipWrapper = styled.div`
    max-width: 350px;
    overflow-wrap: break-word;
`;

const EmailsList: React.FC<IEmailsListProps> = ({ emails, onRemoveEmail }) => {
    return (
        <EmailsListContainer>
            {emails.map((email) => (
                <Tooltip
                    content={
                        <TooltipWrapper>
                            <Text fontVariant="listItem4">{email}</Text>
                        </TooltipWrapper>
                    }
                    key={email}
                >
                    <SimpleChipItem
                        key={email}
                        text={email}
                        onCloseItem={() => onRemoveEmail(email)}
                    />
                </Tooltip>
            ))}
        </EmailsListContainer>
    );
};

export default EmailsList;
